export const dynamicKeywordInsertionRegEx = /[$]{(.|\n)*}[$]/;
export const whitelistedEmojiRegex = /[\u{00a9}\u{00ae}\u{2122}]/gu; //copyright symbols: ©️®™
export const firstLetterOfEveryWordRegex = /(^\w{1})|(\s+\w{1})/g;
